interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionHref?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionHref,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 md:gap-8 mb-8 md:mb-10">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2.5">
          <span className="w-6 h-px bg-primary-500" />
          <span className="text-xs tracking-[0.24em] text-primary-600 font-medium">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {actionHref && actionLabel && (
        <a
          href={actionHref}
          className="shrink-0 inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          {actionLabel}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-base" />
          </span>
        </a>
      )}
    </div>
  );
}